import { GetLaborerTransfersListResponse } from 'api/laborerPortalAPI/serviceTransfer'
import { CallAPIAction, Status } from 'api/types'
import { convertIToIRequestFromResponse, IToIRequest } from 'common/utils/convertResponse/convertIToIResponse'
import { getLaborerTransfersList } from 'redux/actionCreators/laborerPortalAPI/serviceTransfer'
import Actions from 'redux/actions'

type State = {
  laborerTransfersListParams: {
    page: number
    status: string
  }
  requests: Array<IToIRequest>
  lastPage: number
} & Status

const initialState: State = {
  laborerTransfersListParams: {
    page: 0,
    status: '',
  },
  requests: [],
  lastPage: 0,
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_LABORER_TRANSFERS_LIST_ASYNC,
    Actions.GET_LABORER_TRANSFERS_LIST_SUCCESS,
    Actions.GET_LABORER_TRANSFERS_LIST_FAIL,
    GetLaborerTransfersListResponse,
    {},
    {},
    ReturnType<typeof getLaborerTransfersList>['payload']
  >,
): State => {
  switch (action.type) {
    case Actions.GET_LABORER_TRANSFERS_LIST_ASYNC: {
      const {
        params: { status = state.laborerTransfersListParams.status, page = 0 },
      } = action.callAPIActionPayload
      return {
        ...state,
        ...action.status,
        laborerTransfersListParams: {
          page,
          status,
        },
        lastPage: status !== state.laborerTransfersListParams.status ? 0 : state.lastPage,
      }
    }
    case Actions.GET_LABORER_TRANSFERS_LIST_SUCCESS: {
      const {
        params: { status = state.laborerTransfersListParams.status, page = 0 },
      } = action.callAPIActionPayload
      return {
        ...state,
        ...action.status,
        laborerTransfersListParams: {
          page,
          status,
        },
        requests: action.payload.data.map(convertIToIRequestFromResponse),
        lastPage: action.payload.last_page,
      }
    }
    case Actions.GET_LABORER_TRANSFERS_LIST_FAIL:
      return {
        ...state,
        ...action.status,
      }
    default:
      return state
  }
}
